import { useMemo } from 'react';
import { useSiteSettings } from '@namespace/cms';
import { useColorScheme } from '@namespace/themes';
import { useBonusesStore } from '../../store';

export const useBonusImageUrl = (bonusData, oldImageUrl) => {
  const { bonusesAndJackpotsImages = {}, otherSettings = {} } =
    useSiteSettings();
  const { isNewBonusImagesEnabled = false } = otherSettings;
  const bonusTemplatesImages = useBonusesStore('bonusTemplatesImages');
  const {
    imageColorAccent,
    jackpotType,
    isJackpotBonus,
    isBsBonus,
    bonusModelId
  } = bonusData;
  const { colorScheme } = useColorScheme();
  const { selectedColorMode } = colorScheme;

  const bonusImagesUrl = useMemo(() => {
    const {
      baseUrl: bonusImageBaseUrl,
      defaultBonusImage,
      bsTemplates = [],
      crmTemplates = [],
      defaultBonusImageByType = {}
    } = bonusTemplatesImages;

    if (isBsBonus) {
      const { url } =
        bsTemplates.find(({ btId }) => btId === bonusModelId) || {};

      return {
        accentImageUrl: `/${bonusImageBaseUrl}/${imageColorAccent}/${
          url || defaultBonusImageByType[imageColorAccent] || defaultBonusImage
        }`,
        defaultImageUrl: `/${bonusImageBaseUrl}/${selectedColorMode}/${
          url || defaultBonusImageByType[imageColorAccent] || defaultBonusImage
        }`
      };
    }

    const { url } =
      crmTemplates.find(({ btId }) => btId === bonusModelId) || {};

    return {
      accentImageUrl: `/${bonusImageBaseUrl}/${imageColorAccent}/${
        url || defaultBonusImageByType[imageColorAccent] || defaultBonusImage
      }`,
      defaultImageUrl: `/${bonusImageBaseUrl}/${selectedColorMode}/${
        url || defaultBonusImageByType[imageColorAccent] || defaultBonusImage
      }`
    };
  }, [
    bonusModelId,
    bonusTemplatesImages,
    imageColorAccent,
    isBsBonus,
    selectedColorMode
  ]);

  const jackpotImagesUrl = useMemo(() => {
    const { baseUrl: jackpotImageBaseUrl, jackpotImages = {} } =
      bonusesAndJackpotsImages;
    const { default: defaultJackpotImage } = jackpotImages;

    return {
      accentImageUrl: `/${jackpotImageBaseUrl}/${imageColorAccent}/${
        jackpotImages[jackpotType] || defaultJackpotImage
      }`
    };
  }, [bonusesAndJackpotsImages, imageColorAccent, jackpotType]);

  return useMemo(() => {
    if (!isNewBonusImagesEnabled) {
      return { accentImageUrl: oldImageUrl };
    }

    return isJackpotBonus ? jackpotImagesUrl : bonusImagesUrl;
  }, [
    isNewBonusImagesEnabled,
    isJackpotBonus,
    jackpotImagesUrl,
    bonusImagesUrl,
    oldImageUrl
  ]);
};
